import { useState } from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../Assets/png/mariana.png";
import projImg2 from "../Assets/png/spin.png";
import projImg3 from "../Assets/png/coin.png";
import projImg4 from "../Assets/png/googlecert.png";
import projImg5 from "../Assets/png/CS50.png";
import projImg6 from "../Assets/png/runeIcon.png"
import projImg7 from "../Assets/png/pixel.jpg"
import projImg8 from "../Assets/png/homebase.jpg"
import projImg9 from "../Assets/png/mycat.png"
import projImg10 from "../Assets/png/nextstation.png"
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const [animationComplete, setAnimationComplete] = useState(false); // Added state for animation

  const games = [
    {
      title: "RUNE CRYPTOCURRENCY NETWORK",
      description: "A cryptocurrency project made from scratch \nusing python and flask",
      imgUrl: projImg6,
      url: "https://rune-network.onrender.com/",
    },
    {
      title: "Pixel Ring",
      description: "A demake of ELden ring made using Unity Game engine \nand C#",
      imgUrl: projImg7,
      url: "https://retrohelm.itch.io/pixel-ring",
    },
    {
      title: "HomeBase",
      description: "A real estate showcase website made using React js \nand tailwind css",
      imgUrl: projImg8,
      url: "https://homebasege.netlify.app/",
    },
    {
      title: "Mariana",
      description: "Video Game developed using the Unity Game engine \nand C#",
      imgUrl: projImg1,
      url: "https://crimsonjester.itch.io/mariana",
    },
    {
      title: "Spingetti Western",
      description: "Video Game developed using the Unity Game engine and C#",
      imgUrl: projImg2,
      url: "https://crimsonjester.itch.io/spingetti-western",
    },
    {
      title: "Coin Diary",
      description: "A Flask-SQLite CRUD Web-App \nfor keeping tabs on your monthly spending",
      imgUrl: projImg3,
      url: "https://coin-diary.onrender.com",
    },
    {
      title: "My Cat Won't Let Me Out",
      description: "Video Game developed using the Unity Game engine \nand C#",
      imgUrl: projImg9,
      url: "https://clumsywizard.itch.io/my-cat-wont-let-me-out-jam-version",
    },
    {
      title: "Next Station: 100 meters",
      description: "Video Game developed using the Unity Game engine \nand C#",
      imgUrl: projImg10,
      url: "https://clumsywizard.itch.io/nextstation100meters",
    },
  ];

  const certs = [
    {
      title: "Google IT Support Professional Certificate",
      description: "Fundamentals of operating systems, cloud computing, network protocols, cyber security and more",
      imgUrl: projImg4,
      url: "https://coursera.org/share/e27019f195564654eb28ab3af0356baa",
    },
    {
      title: "Harvard's CS50",
      description: "Harvard's introductory course to computer science, teaches the basics of C, Python, Javascript, Algorithms, Data Structures, Web development, Cryptography and more",
      imgUrl: projImg5,
      url: "https://drive.google.com/file/d/1mx1O6EPCaIQez_QiKxhYTWir88ASbJhj/view?usp=sharing",
    },
  ];

  return (
    <section className="projects" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => {
                if (isVisible && !animationComplete) {
                  setAnimationComplete(true); // Set animationComplete to true when the component becomes visible
                }
                return (
                  <div className={animationComplete ? "animate__animated animate__fadeIn": ""}>
                    <h2>Portfolio</h2>
                    <p>Here's my portfolio of projects and certificates.</p>
                    <Tab.Container id="projects-tabs" defaultActiveKey="first">
                      <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                        <Nav.Item>
                          <Nav.Link eventKey="first">Projects</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="second">Certificates</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="third">What's next</Nav.Link>
                        </Nav.Item>
                      </Nav>
                      <Tab.Content id="slideInUp" className={animationComplete ? "animate__animated animate__slideInUp" : ""}>
                        <Tab.Pane eventKey="first">
                          <Row>
                            {games.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })}
                          </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                          <Row>
                            {certs.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })}
                          </Row>                    
                        </Tab.Pane>
                        <Tab.Pane eventKey="third">
                          <p>Right now I am learning how to make videogames using Unreal.</p>
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                );
              }}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      {/* {<img className="background-image-right" src={projImg5}></img>} */}
    </section>
  )
}
